export function trackChange(elementId, action, label)
{
    const select = document.getElementById(elementId);
    if (select) {
        select.addEventListener('change', function () {
            gtag('event', label, { 'event_category': action, 'event_label': this.value });
        });
    }
}